import { createRouter, createWebHistory } from "vue-router";

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      // welcome page not used anymore
      path: "/welcome",
      name: "welcome",
      component: () => import("../views/WelcomeView.vue"),
    },
    {
      path: "/",
      redirect: "/categories",
    },
    {
      path: "/user/admin/users",
      name: "admin-users",
      component: () => import("../views/Admin/UsersView.vue"),
    },
    {
      path: "/admin/user/:id", // used in email links
      redirect: (to) => ({
        name: "admin-user-detail",
        params: { id: to.params.id as string },
      }),
    },
    {
      path: "/user/admin/users/:id",
      name: "admin-user-detail",
      component: () => import("../views/Admin/UserDetailView.vue"),
      props: (route) => ({
        userId: route.params.id,
      }),
    },
    {
      path: "/user/admin/disabled-dates",
      name: "admin-disabled-dates",
      component: () => import("../views/Admin/DisabledDatesView.vue"),
    },
    {
      path: "/user/admin/more-settings",
      name: "admin-more-settings",
      component: () => import("../views/Admin/MoreSettingsView.vue"),
    },
    {
      path: "/categories",
      name: "categories",
      component: () => import("../views/CategoriesView.vue"),
    },
    {
      path: "/category/:categoryId",
      name: "category",
      component: () => import("../views/CategoryView.vue"),
      props: (route) => ({
        categoryId: route.params.categoryId,
      }),
    },
    {
      path: "/special-category/:categoryId",
      name: "special-category",
      component: () => import("../views/CategoryView.vue"),
      props: (route) => ({
        categoryId: route.params.categoryId,
      }),
    },
    {
      path: "/cart",
      name: "cart",
      component: () => import("../views/CartView.vue"),
    },
    {
      path: "/login",
      name: "login",
      component: () => import("../views/LoginView.vue"),
      meta: {
        skipAuth: true,
      },
    },
    {
      path: "/register",
      name: "register",
      component: () => import("../views/RegisterView.vue"),
      meta: {
        skipAuth: true,
      },
    },
    {
      path: "/password-reset-request",
      name: "password-reset-request",
      component: () => import("../views/PasswordResetStep1View.vue"),
      meta: {
        skipAuth: true,
      },
    },
    {
      path: "/password-reset/:userId/:resetToken",
      name: "password-reset",
      component: () => import("../views/PasswordResetStep2View.vue"),
      props: (route) => ({
        userId: route.params.userId as string,
        resetToken: route.params.resetToken as string,
      }),
      meta: {
        skipAuth: true,
      },
    },
    {
      path: "/orders",
      name: "orders",
      component: () => import("../views/OrdersView.vue"),
    },
    {
      path: "/user/profile",
      name: "profile",
      component: () => import("../views/ProfileView.vue"),
    },
    {
      path: "/user/invoices",
      name: "invoices",
      component: () => import("../views/InvoicesView.vue"),
    },
    {
      // currently the global search is not used, only in-category search is used
      path: "/search",
      name: "search",
      component: () => import("../views/SearchView.vue"),
    },
  ],
});

export default router;
